<template>
    <div
        v-if="visible"
        class="cookie-consent"
        role="dialog"
        aria-modal="true"
        aria-labelledby="cookie-consent-title"
    >
        <div class="cookie-consent__mask"></div>
        <div class="cookie-consent__dialog">
            <div class="flex justify-end shrink-0 px-4 pt-3">
                <button type="button" @click="doNotSetCookie()" class="block hover:bg-gray-200 rounded-full p-1" aria-label="Close">
                    <svg xmlns="http://www.w3.org/2000/svg" class="fill-current text-gray-800 rounded-full" viewBox="0 0 512 512" height="32" width="32"><title>Close</title><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M368 368L144 144M368 144L144 368"/></svg>
                </button>
            </div>
            <div class="cookie-consent__body px-6">
                <div id="cookie-consent-title" class="font-medium text-md">
                    {{ localizedText(cookie.title) }}
                </div>
                <div class="text-sm text-gray-500 mt-6">{{ localizedText(cookie.descr) }}</div>
            </div>
            <div class="cookie-consent__actions flex justify-between items-center px-6 pb-5 pt-4">
                <button type="button" class="text-gray-500 underline bg-transparent p-0" @click="doNotSetCookie()">{{ localizedText(cookie.button_not_accept) }}</button>
                <button type="button" @click="setCookie()" class="text-white bg-black hover:bg-blue-800 focus:outline-none focus:ring-4 focus:ring-blue-300 font-medium rounded-full text-sm px-5 py-2.5 text-center">
                    {{ localizedText(cookie.button_accept) }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'AppBottomPrivacyCookie',

	data() {
		return {
            visible: this.shouldShowCookieBanner(),
            cookie: {
                title: {
                    en: 'This site uses cookies and services to collect technical data from visitors to ensure performance and improve the quality of service.', 
                    ru: 'Этот сайт использует файлы cookies и сервисы сбора технических данных посетителей для обеспечения работоспособности и улучшения качества обслуживания.',
                    pl: 'Ta strona używa plików cookies dla zbierania technicznych danych użytkowników w celu zapewnienia wydajności divalności witryny oraz polepszenia jakości obsługi.',
                },
                descr: {
                    en: 'By clicking the "Accept" button, you agree to this.',
                    ru: 'Нажимая кнопку "Принять", вы соглашаетесь с этим.',
                    pl: 'Poprzez kliknięcie „Akceptuję”, wyrażasz na to zgodę.'
                },
                button_detail: {
                    en: 'Detailed information',
                    ru: 'Детальная информация',
                },
                button_accept: {
                    en: 'Accept all',
                    ru: 'Принять все',
                    pl: 'Akceptuję wszystkie pliki cookies'
                },
                button_not_accept: {
                    en: 'Do not use',
                    ru: 'Не использовать',
                    pl: 'Nie używać'
                },                
                page: {
                    en: "<div><h3>1. Introduction: Cookies are used on this website</h3><p>By using this website, you consent to the processing of cookies, user data (location information; OS type and version; browser type and version; device type and screen resolution; source from where the user went to the site; from which site or through which advertisement; OS and Browser language; which pages opens and which buttons the user clicks on; ip address) for the purposes of website operation, retargeting and statistical research and reviews. If you do not want your data to be processed, you must leave this site.advertising; OS and Browser language; which pages are opened and which buttons are clicked by the user; ip address)</p><h3>2. About cookies</h3><p>Cookies are used on this website. A cookie is a small, simple file (a string of letters and numbers) that is sent along with the pages of a website and stored by the browser on your computer's hard drive. On subsequent visits, the information from this file can be sent back to our servers.</p><p>Web servers can use cookies to identify and track users when browsing various pages of a website, as well as determine whether they have visited it before.</p><h3>3. Cookies and personal data</h3><p>The cookies that we store through our website do not contain any information that allows us to identify you.</p><h3>4.Enabling, disabling and deleting cookies</h3><p>More detailed information about enabling, disabling and deleting cookies can be found in the instructions for your browser or in its help.</p><h3>5.Additional information about cookies</h3><p>More information about cookies can be found on <a href='https://ru.wikipedia.org/wiki/Cookie'>Wikipedia</a>, or other websites.</p></div>",
                    ru: "<div><h3>1. Вступление: на этом веб-сайте используются файлы cookie</h3><p>Используя этот веб-сайт, Вы даете согласие на обработку файлов cookie, пользовательских данных (сведения о местоположении; тип и версия ОС; тип и версия Браузера; тип устройства и разрешение его экрана; источник откуда пользователь перешел на сайт; с какого сайта или по какой рекламе; язык ОС и Браузера; какие страницы открывает и на какие кнопки нажимает пользователь; ip-адрес) в целях функционирования сайта, проведения ретаргетинга и проведения статистических исследований и обзоров. Если Вы не хотите, чтобы Ваши данные обрабатывались, Вы должны покинуть данный сайт.</p><h3>2. О файлах cookie</h3><p>На этом веб-сайте используются файлы cookie. Cookie — это небольшой простой файл (строка из букв и цифр), который отправляется вместе со страницами веб-сайта и сохраняется браузером на жестком диске вашего компьютера. При последующих посещениях информация из этого файла, может быть отправлена обратно на наши серверы.</p><p>Веб-серверы могут с помощью файлов cookie идентифицировать и отслеживать пользователей при просмотре различных страниц веб-сайта, а также определять, посещали ли они его ранее.</p><h3>3. Файлы cookie и персональные данные</h3><p>Файлы cookie, которые мы сохраняем через свой веб-сайт, не содержат каких-либо сведений, позволяющих установить вашу личность.</p><h3>4. Включение, отключение и удаление файлов cookie</h3><p>Более подробную информацию о включении, отключении и удалении файлов cookie можно найти в инструкциях к вашему браузеру или в его справке.</p><h3>5. Дополнительные сведения о файлах cookie</h3><p>Дополнительные сведения о файлах cookie можно найти в <a href='https://ru.wikipedia.org/wiki/Cookie'>Википедии</a>, или других веб-сайтах.</p></div>",
                    pl: "<div><h3>1. Wstęp: Ta witryna wykorzystuje pliki cookie</h3><p>Korzystając z tej witryny, wyrażasz zgodę na przetwarzanie plików cookie, danych użytkownika (informacje o lokalizacji; typ i wersja systemu operacyjnego; typ i wersja przeglądarki; typ urządzenia i rozdzielczość ekranu; źródło, z którego użytkownik przeszedł na stronę; z jakiej strony lub przez jaką reklamę; język systemu operacyjnego i przeglądarki; które strony otwierają i w które przyciski użytkownik klika; adres ip) dla celów divania strony, retargetingu oraz badań i recenzji statystycznych . Jeżeli nie chcesz, aby Twoje dane były przetwarzane, musisz opuścić tę stronę.reklama; Język systemu operacyjnego i przeglądarki; które strony są otwierane i które przyciski są klikane przez użytkownika; adres IP)</p><h3>2. O plikach cookie</h3><p>Na tej stronie używane są pliki cookie. Cookie to mały, prosty plik (ciąg liter i cyfr), który jest wysyłany wraz ze stronami serwisu internetowego i przechowywany przez przeglądarkę na twardym dysku Twojego komputera. Podczas kolejnych odwiedzin informacje z tego pliku mogą być przesyłane z powrotem na nasze serwery.</p><p>Serwery internetowe mogą wykorzystywać pliki cookie do identyfikowania i śledzenia użytkowników podczas przeglądania różnych stron witryny internetowej, a także ustalania, czy odwiedzili oni to wcześniej.</p><h3>3. Pliki cookie i dane osobowe</h3><p>Pliki cookie, które przechowujemy za pośrednictwem naszej witryny, nie zawierają żadnych informacji, które pozwalają nam Cię zidentyfikować.</p><h3>4. Włączanie, wyłączanie i usuwanie plików cookie</h3> <p>Szczegółowe informacje na temat włączania, wyłączania i usuwania plików cookie znajdziesz w instrukcji przeglądarki lub w jej pomocy.</p><h3>5. Dodatkowe informacje o plikach cookie</h3><p>Więcej informacji o plikach cookie pliki cookie można znaleźć na <a href='https://ru.wikipedia.org/wiki/Cookie'>Wikipedia</a> lub na innych stronach internetowych.</p></div>"
                }
            }          
		}
	},

    watch: {
        '$root.is_widget'(isWidget) {
            if (isWidget) {
                this.visible = false;
            }
        },
        visible(isVisible) {
            if (isVisible) {
                this.lockPageScroll();
            } else {
                this.unlockPageScroll();
            }
        },
    },

    mounted() {
        if (this.visible) {
            this.lockPageScroll();
        }
    },

    beforeDestroy() {
        this.unlockPageScroll();
    },

    methods: {
        localizedText(value) {
            const text = this.$root.getLangText(value);
            return text === '' ? value['en'] : text;
        },

        isEmbedContext() {
            return this.$root.is_widget || this.isWidgetContext();
        },

        shouldShowCookieBanner() {
            if (this.isEmbedContext()) {
                return false;
            }

            if (this.$route.name === 'locations-occupancy') {
                return false;
            }

            if (location.pathname.indexOf('/chat') > -1) {
                return false;
            }

            try {
                return localStorage.getItem('access_cookie') == null;
            } catch (e) {
                return true;
            }
        },

        saveCookiePreference(value) {
            try {
                localStorage.setItem('access_cookie', value ? 'true' : 'false');
            } catch (e) {
                // Keep banner closable even if storage is unavailable.
            }
        },

        lockPageScroll() {
            if (typeof document === 'undefined') {
                return;
            }

            document.documentElement.style.overflow = 'hidden';
            document.body.style.overflow = 'hidden';
        },

        unlockPageScroll() {
            if (typeof document === 'undefined') {
                return;
            }

            document.documentElement.style.overflow = '';
            document.body.style.overflow = '';
        },

        setCookie() {
            this.visible = false;
            this.saveCookiePreference(true);
        },

        doNotSetCookie() {
            this.visible = false;
            this.saveCookiePreference(false);
        },
    },
}
</script>

<style scoped>
.cookie-consent {
    position: fixed;
    inset: 0;
    z-index: 1100;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    padding: 12px;
    padding-bottom: max(12px, env(safe-area-inset-bottom));
}

.cookie-consent__mask {
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.45);
}

.cookie-consent__dialog {
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    width: min(95%, 450px);
    max-height: 100%;
    min-height: 0;
    background: #fff;
    border-radius: 20px;
    box-shadow: 0 8px 24px rgb(0 0 0 / 12%);
}

.cookie-consent__body {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
}

.cookie-consent__actions {
    flex-shrink: 0;
}
</style>
